import { BANK_FUNDING_METHODS, bankFundingContract, providerFundingMethod, } from '../bank-transfers/types.js';
import { fundingMethodPolicy } from './manifest-policy.js';
import { isGeographyAllowed, isHostedFundingMethod, } from './policy.js';
import { sandboxLocationOverrideAllowed } from './sandbox-location.js';
/** Display-only diagnostics never add a method to the executable eligibility list. */
export function unavailableBankMethods(options) {
    if (!options.manifest.onramp.providers.moonpay.enabled)
        return [];
    return BANK_FUNDING_METHODS.flatMap((method) => {
        const policy = fundingMethodPolicy(options.manifest, method);
        if (!policy.enabled ||
            !policy.surfaces.includes(options.surface) ||
            options.methods.includes(method))
            return [];
        return [{ method, reason: unavailableReason(method, options) }];
    });
}
function unavailableReason(method, options) {
    if (options.context.asset !== 'USDC_SOL')
        return 'asset_unavailable';
    const policy = fundingMethodPolicy(options.manifest, method);
    if (!sandboxLocationOverrideAllowed(options.sandboxIgnoreLocationRestrictions, options.context.environment) &&
        !isGeographyAllowed(policy.geography, options.context.country, options.context.subdivision))
        return 'region_unavailable';
    if (!options.connected)
        return 'connection_required';
    const config = options.configs.find((entry) => entry.type === providerFundingMethod(method));
    if (!config?.availability.active ||
        !config.capabilities.supportedTransactionTypes.includes('buy'))
        return 'provider_unavailable';
    if (config.capabilities.requiresWidget !== isHostedFundingMethod(method))
        return 'execution_unavailable';
    const currency = bankFundingContract(method)?.currency;
    if (!currency || !config.capabilities.supportedCurrencies.includes(currency))
        return 'currency_unavailable';
    // A compatible advertised rail excluded after frame rejection is an execution
    // limitation, not evidence that MoonPay stopped offering the bank method.
    return 'execution_unavailable';
}
